<template>
  <div :class="getClassName('approva-rail')">
    <ul :class="getClassName('approva-rail__items')">
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>1 本 1 本手作業でお作りしているため、色ムラや個体差がある場合ございます。
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_1, value.curtainrail_approval_1),
            ]"
            :for="`curtainrail-approval-1`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-1`"
              :value="1"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>幅 150㎝ 以上のレールは、耐久性の観点から壁との接着部分（ブラケット）が付属します。
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_2, value.curtainrail_approval_2),
            ]"
            :for="`curtainrail-approval-2`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-2`"
              :value="2"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>取り付けの際は下地を必ずご確認下さい。
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_3, value.curtainrail_approval_3),
            ]"
            :for="`curtainrail-approval-3`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-3`"
              :value="3"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>サイズにつきましては全てビス穴からビス穴までの長さとなっております。（両端 1cm ずつゆとりを持たせてご注文ください）
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_4, value.curtainrail_approval_4),
            ]"
            :for="`curtainrail-approval-4`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-4`"
              :value="4"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>商品をカートに入れた後、ご購入手続き画面の「備考」欄にご希望のサイズをご記入ください。
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_5, value.curtainrail_approval_5),
            ]"
            :for="`curtainrail-approval-5`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-5`"
              :value="5"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>オーダーに関しましては、受注から納品まで２～３週間いただいております。
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_6, value.curtainrail_approval_6),
            ]"
            :for="`curtainrail-approval-6`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-6`"
              :value="6"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
      <li :class="getClassName('approva-rail__item')">
        <div :class="getClassName('approva-rail__title')">
          <span class="purchase__counter">※</span>お客様都合によるご注文後のキャンセルは承りません。
        </div>
        <div :class="getClassName('approva-rail__content__wrap')">
          <label
            :class="[
              ...getClassNameActive('approva-rail__action', this.curtainrail_approval_7, value.curtainrail_approval_7),
            ]"
            :for="`curtainrail-approval-7`">
            <div :class="getClassName('approva-rail__content')">
              承認しました
            </div>
            <input
              type="radio"
              :id="`curtainrail-approval-7`"
              :value="7"
              v-model="internalValue"
              v-show="false"
            />
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    // const uuid = uuidv4();
    return {
      // uuid: uuid,
      curtainrail_approval_1: { id: 1, checked: false },
      curtainrail_approval_2: { id: 2, checked: false },
      curtainrail_approval_3: { id: 3, checked: false },
      curtainrail_approval_4: { id: 4, checked: false },
      curtainrail_approval_5: { id: 5, checked: false },
      curtainrail_approval_6: { id: 6, checked: false },
      curtainrail_approval_7: { id: 7, checked: false },
      approvalIronCurtainRailFlg : false,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value.ironcurtainrail;
      },
      set(newValue) {
        if (newValue === 1) {
          this.curtainrail_approval_1.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_1: newValue });
        } else if (newValue === 2) {
          this.curtainrail_approval_2.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_2: newValue });
        } else if (newValue === 3) {
          this.curtainrail_approval_3.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_3: newValue });
        } else if (newValue === 4) {
          this.curtainrail_approval_4.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_4: newValue });
        } else if (newValue === 5) {
          this.curtainrail_approval_5.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_5: newValue });
        } else if (newValue === 6) {
          this.curtainrail_approval_6.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_6: newValue });
        } else if (newValue === 7) {
          this.curtainrail_approval_7.checked = true;
          this.$emit('input', { ...this.value, curtainrail_approval_7: newValue });
        }
        if (this.checkApproval()) {
          this.approvalIronCurtainRailFlg = true;
          this.$emit('approvalIronCurtainRail', this.approvalIronCurtainRailFlg);
        }
      },
    },
  },
  methods: {
    checkApproval(){
      // 全て承認したかチェック
      if (this.curtainrail_approval_1.checked && this.curtainrail_approval_2.checked && this.curtainrail_approval_3.checked && this.curtainrail_approval_4.checked && this.curtainrail_approval_5.checked && this.curtainrail_approval_6.checked && this.curtainrail_approval_7.checked) return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';

.approva-rail {
  &__items {
    &--sp {
    }
  }
  &__item {
    &:not(:first-of-type) {
      border-top: solid 1px #b9b9b9;
    }
  }
  &__title {
    padding: 17px 24px 0;
  }
  &__action {
    width: 100%;
    height: 100%;
    padding: 17px 29px 25px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    &::before {
      content: '';
      background: url(../images/check.svg) no-repeat center center;
      background-color: #fff;
      background-size: 13px 10px;
      width: 26px;
      height: 26px;
      border: solid 1px #d0d0d0;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 15px;
      flex: 0 0 auto;
      transition: all 0.2s ease 0s;
    }
    &--active::before {
      background-color: $color__active;
      border-color: $color__active;
    }
    &--disabled {
      cursor: auto;
      &::before {
        border: solid 1px transparent;
      }
    }
    &--sp {
      width: 200px;
    }
  }
  &__content__wrap {
    &--sp {
      display: flex;
      justify-content: center;
    }
  }
  &__content {
    &--sp {
      line-height: 3rem;
    }
  }
  &__stock {
  }
}
</style>
